<template>
  <div class="name-list pop" :class="{ 'show-all': showFull }">
    <Hamburger class="white" :open="true" @click.native="toggleMe"/>
    <div class="content summary">
      <div class="pre">
        <h5>Thank you for acknowledging
          <br>independent music!
        </h5>
        <div v-for="(group, index) in arrayedNames" :key="index">
          <h6>{{group.letter.toUpperCase()}}</h6>
          <p>
            <span
              v-for="(name, index) in group.names"
              :key="name + '_' + index"
            >{{name + (+index === group.names.length - 1 ? '' : ',&nbsp;') }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="content center">
      <a class="button" @click.prevent="togglePage">{{ showFull ? 'Read less': 'Read more' }}</a>
    </div>
  </div>
</template>

<script>
//  import fetchData from '@/api/fetchData.js'
import Hamburger from '@/components/Hamburger'
import names from '@/api/onlyNames_1212.json'
export default {
  name: 'NameList',
  data () {
    return {
      page: {},
      sortedNames: {},
      showFull: false
    }
  },
  computed: {
    arrayedNames () {
      return Object.keys(this.sortedNames).map((a, index) => {
        return {
          letter: a,
          names: this.sortedNames[a]
        }
      }).sort((a, b) => {
        if (!isNaN(b.letter.charAt(0))) return -1
        return a.letter > b.letter ? 1 : -1
      })
    }
  },
  methods: {
    togglePage () {
      this.showFull = !this.showFull
      this.$emit('showingfull', this.showFull)
      if (!this.showFull) {
        this.$scrollTo('#start-view', 20)
      }
    },
    toggleMe () {
      this.$emit('toggle')
    },
    sortNames () {
      const abc = { '0-9': [] }
      //  var english = /^[A-Za-z0-9]*$/
      names.forEach((a) => {
        if (!a) return
        if (!isNaN(a.charAt(0))) {
          abc['0-9'].push(a)
          return
        }
        if (abc[a.charAt(0).toLowerCase()]) {
          abc[a.charAt(0).toLowerCase()].push(a)
          return
        }
        abc[a.charAt(0).toLowerCase()] = [a]
      })
      this.sortedNames = abc
    }
  },
  mounted () {
    //  fetchData()
    //  console.log(names)
    this.sortNames()
  },
  props: {
    msg: String
  },
  components: {
    Hamburger
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hamburger {
  position: absolute;
  top: 43px;
  right: 33px;
  @media only screen and (max-width: 700px) {
    top: 33px;
    right: 15px;
  }
  @media only screen and (max-width: 600px) {
    top: 33px;
    right: 0px;
  }
}
h5 {
  text-align: center;
  @media only screen and (max-width: 600px) {
    margin-top: 50px;
  }
}
.play {
}
.pop {
  height: auto;
  display: block;
  top: 0;
  position: absolute;
  width: 100vw;
  z-index: 997;
  .content {
    &.summary {
      transition: all 0.5s ease;
      max-height: 80vh;
      overflow: hidden;
      //  -webkit-mask-image: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
      //  mask-image: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
      -webkit-mask-image: -webkit-gradient(
        linear,
        left 75%,
        left bottom,
        from(rgba(0, 0, 0, 1)),
        to(rgba(0, 0, 0, 0))
      );
      mask-image: gradient(
        linear,
        left 75%,
        left bottom,
        from(rgba(0, 0, 0, 1)),
        to(rgba(0, 0, 0, 0))
      );
    }
    .button {
      background-color: #2effc3;
      color: #000075;
      &:hover {
        background-color: #ffff76;
      }
    }
    max-width: 890px;
    margin: auto;
    p {
      font-size: 0.95em;
      line-height: 1.4em;
      @media only screen and (max-width: 600px) {
        font-size: 0.8em;
        line-height: 1.2em;
      }
    }
  }
  &.show-all {
    height: auto;
    @media only screen and (max-width: 600px) {
      height: 100%;
      overflow-y: scroll;
      position: fixed;
      top: 0px;
    }
    .content {
      &.summary {
        max-height: 9999px;
        -webkit-mask-image: -webkit-gradient(
          linear,
          left 75%,
          left bottom,
          from(rgba(0, 0, 0, 1)),
          to(rgba(0, 0, 0, 1))
        );
        mask-image: gradient(
          linear,
          left 75%,
          left bottom,
          from(rgba(0, 0, 0, 1)),
          to(rgba(0, 0, 0, 1))
        );
        &.summary:after {
          display: none;
        }
      }
    }
  }
}
</style>
